import { Component, OnInit } from '@angular/core';
import { PurchaseService } from '../services/purchase.service';
import { ProductService } from '../../products/services/product.service';
import { PurchaseProductService } from '../services/purchase-product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonService } from '../../person/services/person.service';
import htmlDocx from 'html-docx-js/dist/html-docx';
import * as FileSaver from 'file-saver';
import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';




declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css'],
  providers:[PurchaseService,ProductService,PurchaseProductService,PersonService]
})
export class PurchaseComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  person: any = {};
  purchase: any = {};
  purchaseProducts: any = [];
  productLoaded : boolean = false;
  role:number = 3;
  method_of_payment:number = 1;

  constructor(private purchaseService: PurchaseService, private productService:ProductService, private purchaseProductService:PurchaseProductService,
              private route: ActivatedRoute, private router: Router,private personService:PersonService,public toastr: ToastsManager) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
       this.id = params['id'];
       this.getPurchase();
      }
    });
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }
 

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  addAnotherProduct(){
    this.productLoaded = false;
  }

  handlePersonSelected($event){
    if ($event.id != undefined){
      this.purchase.person = $event;
      //TODO maybe this line will be remove
      this.person = $event;
      //Copy fields from person to entity
      this.copyPersonData(this.person, this.purchase);
    }
  }

  copyPersonData(person, entity){
    entity['nif'] = person.nif;
    entity['name'] = person.name;
    entity['surname'] = person.surname;
    entity['address'] = person.address;
    entity['cp'] = person.cp;
    entity['town'] = person.town;
    entity['state'] = person.state;
    entity['born_date'] = person.born_date;
  }

  handleAddProduct($event){
    $event.stock = $event.stock > 0?$event.stock:1;
    this.calculatetotal(this.purchaseProducts,$event);
    this.savePurchase().then(() =>{
      ///this.id = this.purchase.id;
      this.saveProductAndRelationToPurchase($event);
      //this.getPurchase();
    });
    this.productLoaded = true;
  }

  calculatetotal(purchaseProducts, $event){
    this.purchase.total_amount = 0;
    purchaseProducts.forEach( (purchaseProduct)=>{
      this.purchase.total_amount += this.roundValue(purchaseProduct.product.stock * purchaseProduct.product.purchase_price);
    });
    if ($event != null && $event.purchase_price != undefined){
      this.purchase.total_amount += this.roundValue(parseInt($event.stock) * parseFloat($event.purchase_price));
    }
  }
  roundValue(value){
    return Math.round(value * 100) / 100;
  }

  getPurchase(){
    return new Promise((resolve, reject) => {
      this.purchaseProducts = [];
      this.purchaseService.get(this.id).subscribe((purchase) => {
        this.purchase = purchase;
        this.person = purchase.person;
        this.purchase.nameAndSurname = this.person.name +" "+ this.person.surname;
        this.purchase.naturalCreatedAt = moment(this.purchase.createdAt).format("DD-MM-YYYY HH:mm");
        this.purchase.createdByNameAndSurname = this.purchase.createdBy.name +" "+ this.purchase.createdBy.surname;
        let params ={
          purchase: purchase.id
        }
        this.method_of_payment = this.purchase.method_of_payment == "Efectivo"? 1: this.purchase.method_of_payment == "Bizum"? 2:this.purchase.method_of_payment == "Transferencia"? 3:1;
        this.purchaseProductService.query(params).subscribe((purchaseProducts) =>{
          purchaseProducts.forEach(purchaseProduct=>{
            this.purchaseProducts.push(purchaseProduct);
            purchaseProduct.product.naturalDescription = "";
            if (purchaseProduct.product.type=="1" ){
               if(purchaseProduct.product.sub_type=="1"){
                purchaseProduct.product.naturalDescription += "Tipo:Móvil"+", ";
                }
              if(purchaseProduct.product.sub_type=="2"){
               purchaseProduct.product.naturalDescription += "Tipo:Tablet"+", ";
              }  
            }
            if(purchaseProduct.product.type=="2"){
               purchaseProduct.product.naturalDescription += "Tipo:Consolas"+", ";
            }
            if(purchaseProduct.product.type=="3"){
               purchaseProduct.product.naturalDescription +="Cantidad:"+purchaseProduct.product.stock+", "+purchaseProduct.product.naturalDescription; 
            }
            if (purchaseProduct.product.type=="4" ){
               if(purchaseProduct.product.sub_type=="1"){
                purchaseProduct.product.naturalDescription += "Tipo:PC"+", ";
                }
              if(purchaseProduct.product.sub_type=="2"){
              purchaseProduct.product.naturalDescription += "Tipo:Portatil"+", ";
              }  
            }
            if (purchaseProduct.product.brand){
              purchaseProduct.product.naturalDescription += "Marca:"+purchaseProduct.product.brand+", ";
            }
            if (purchaseProduct.product.model){
              purchaseProduct.product.naturalDescription += "Modelo:"+purchaseProduct.product.model+", ";
            }
            if (purchaseProduct.product.telephone_company){
              purchaseProduct.product.naturalDescription += "Operador:"+purchaseProduct.product.telephone_company+", ";
            }
            if (purchaseProduct.product.storage_capacity){
              purchaseProduct.product.naturalDescription += "Capacidad:"+purchaseProduct.product.storage_capacity+", ";
            }
            if (purchaseProduct.product.status){
              purchaseProduct.product.naturalDescription += "Estado:"+purchaseProduct.product.status+", ";
            }

            if (purchaseProduct.product.imei){
              purchaseProduct.product.naturalDescription += "Imei:"+purchaseProduct.product.imei+", ";
            }
            if (purchaseProduct.product.imei2){
              purchaseProduct.product.naturalDescription += "Imei2:"+purchaseProduct.product.imei2+", ";
            }  
            if (purchaseProduct.product.pin){
              purchaseProduct.product.naturalDescription += "Pin:"+purchaseProduct.product.pin+", ";
            }  
            if (purchaseProduct.product.so){
              purchaseProduct.product.naturalDescription += "Sistema Operativo:"+purchaseProduct.product.so+", ";
            }
            if (purchaseProduct.product.ram){
              purchaseProduct.product.naturalDescription += "Ram:"+purchaseProduct.product.ram+", ";
            }
            if (purchaseProduct.product.description){
              purchaseProduct.product.naturalDescription += "Descripción:"+purchaseProduct.product.description+", ";
            }
            if (purchaseProduct.product.serial_number){
              purchaseProduct.product.naturalDescription += "Número de serie:"+purchaseProduct.product.serial_number+", ";
            }
            if (purchaseProduct.product.stock == undefined){
              purchaseProduct.product.stock =  '';
            }
            if (purchaseProduct.product.purchase_price == undefined){
              purchaseProduct.product.purchase_price =  '';
            }
            if (purchaseProduct.product.sale_price == undefined){
              purchaseProduct.product.sale_price =  '';
            }
            purchaseProduct.product.naturalDescription = purchaseProduct.product.naturalDescription.slice(0, -2);
            purchaseProduct.product.naturalDescription = purchaseProduct.product.naturalDescription + "; "
          });
          resolve();
          this.productLoaded = true;
          if (this.purchase.barcode){
            setTimeout( ()=>{
              JsBarcode("#barcode",this.purchase.barcode,{format: "ean13"});
              this.purchase.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
            },0)
          }
        });
      });
    });
  }

  saveProductAndRelationToPurchase(product){
    this.saveProduct(product).then((productSaved) =>{
      this.savePurchaseProduct(productSaved).then((purchaseProduct)=>{
        purchaseProduct['product'] = productSaved ; 
        this.purchaseProducts.push(purchaseProduct);
        this.getPurchase();
      })
    });
  }


  savePurchaseProduct(product){
    return new Promise((resolve, reject) => {
      this.purchaseProductService.create(this.returnPurchaseProductProperties(product,this.purchase))
      .subscribe((purchaseProduct) => {
        resolve(purchaseProduct);
      });
    });
  }
  savePurchase(){
    return new Promise((resolve, reject) => {
      if (this.purchase.id == undefined){
        this.generateBarcodeNumber(this.purchase.nif,this.purchase.person.id).then((barcode)=>{
          this.purchase.barcode = barcode;
          let body = this.returnPurchaseProperties(this.purchase);
          body.status = "No Guardada";
          this.purchaseService.create(body)
          .subscribe((purchase) => {
            this.purchaseService.get(purchase.id).subscribe((purchase) => {
              this.purchase = purchase;
              this.id = purchase.id;
              resolve();
            });
          });
        });
      }else{
        this.purchaseService.update(this.returnPurchaseProperties(this.purchase))
        .subscribe((purchase) => {
          purchase.createdByNameAndSurname = this.purchase.createdBy.name +" "+ this.purchase.createdBy.surname;
          this.purchase = purchase;
          this.person = purchase.person;
          if (this.purchase.barcode){
            setTimeout( ()=>{
              JsBarcode("#barcode",this.purchase.barcode,{format: "ean13"});
              this.purchase.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
            },0)
          } 
          resolve();   
        });
      }
    });
  }
  saveProduct(product){
    return new Promise((resolve, reject) => {
      if (product.id == undefined){
        this.productService.create(this.returnProductProperties(product))
        .subscribe((product) => {
          resolve(product);
        });
      }else{
        this.productService.update(this.returnProductProperties(product))
        .subscribe((product) => {
          resolve();
        });
      }
    });
  }

  deletePurchaseProduct(purchaseProduct){
    if(window.confirm('¿Está seguro de borrar este producto?')){
      this.purchaseProductService.delete(purchaseProduct.id)
        .subscribe(() => {
            this.productService.delete(purchaseProduct.product.id)
            .subscribe(() => {
              this.getPurchase().then((purchaseProduct)=>{
                this.calculatetotal(this.purchaseProducts,null);
                this.savePurchase().then((purchase) =>{
                });
              });
            });
      });   
    }
  }

  recalculateTotals(){
    this.calculatetotal(this.purchaseProducts,null);
      this.savePurchase().then(() =>{
        this.getPurchase();
      });
  }

  returnPurchaseProductProperties(product,purchase){
    var properties = {
      product: product,
      purchase: purchase,
    }
    return properties;
  }
  returnPurchaseProperties(purchase){
    var properties = {
      date: purchase.date?purchase.date:new Date(),
      barcode: purchase.barcode,
      total_amount: purchase.total_amount,
      method_of_payment: purchase.method_of_payment?purchase.method_of_payment:"Efectivo",
      status: ''
    }
    if (purchase.id){
      properties['id'] = purchase.id;
    }else{
      properties['person'] = purchase.person.id;
      properties['nif'] = purchase.nif;
      properties['name'] = purchase.name;
      properties['surname'] = purchase.surname;
      properties['address'] = purchase.address;
      properties['cp'] = purchase.cp;
      properties['town'] = purchase.town;
      properties['state'] = purchase.state;
      properties['born_date'] = purchase.born_date;
    }
    return properties;
  }

  returnProductProperties(product){
    var properties = {
      type: product.type,
      sub_type: product.sub_type,
      brand: product.brand,
      model: product.model,
      storage_capacity: product.storage_capacity,
      status: product.status,
      serial_number: product.serial_number,
      charger: product.charger,
      case: product.case,
      original_box: product.original_box,
      description: product.description,
      purchase_price: product.purchase_price,
      sale_price: product.sale_price,
      stock: product.stock,
      telephone_company: product.telephone_company,
      imei: product.imei,
      imei2: product.imei2,
      accessories: product.accessories,
      so: product.so,
      cpu: product.cpu,
      ram: product.ram,
      pin: product.pin,
      subtype:product.subtype    
    }
    if (product.id){
      properties['id'] = product.id;
    }
    return properties;
  }

  generateBarcodeNumber(nif, id){
    return new Promise((resolve, reject) => {
      let barcode = '1';
      let params = {
        where: {nif:nif},
        sort: 'id ASC'
      };
      id = id.toString();
      for (let i=id.length; i<6; i++){
        id = '0'+id;
      }
      this.purchaseService.query(params).subscribe((purchases) => {
        let purchasesCount = '0';
        if (purchases.length > 0){
          let barcode = purchases[purchases.length -1].barcode;
          purchasesCount = (parseInt(barcode.substr(barcode.length - 5)) + 1).toString();
        }
        for (let i=purchasesCount.length; i<5; i++){
          purchasesCount = '0'+purchasesCount;
        }
        resolve(barcode + id + purchasesCount);
      });
    });
  }

  markAsPrinted(){
    var purchase= {
      id: this.purchase.id,
      printed: true
    }
    this.purchaseService.update(purchase)
      .subscribe((purchase) => {
        this.getPurchase().then(()=>{
        });
      });
  }

  updateMethodOfPayment(){
    var purchase= {
      id: this.purchase.id,
      method_of_payment: this.method_of_payment == 1? "Efectivo":this.method_of_payment == 2? "Bizum":this.method_of_payment == 2? "Transferencia":""
    }
    this.purchaseService.update(purchase)
      .subscribe((purchase) => {
        this.getPurchase().then(()=>{
        });
      });
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }
  

  base64DataURLToArrayBuffer(dataURL) {
    const string_base64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    var binary_string;
    binary_string = new Buffer(string_base64, 'base64').toString('binary');
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      var ascii = binary_string.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes.buffer;
  };

  getDateForFooter(date){
    let dateObj=moment(date);
    let month=dateObj.lang("es").format('MMMM');
    let hour = dateObj.format('HH:mm');
    let day = dateObj.format('DD');
    let year = dateObj.format('YYYY');
    let dateResult = day+ " de " + month + " de " + year;
    return dateResult;  
  }

  saveAndDownload(){
    this.savePurchase().then(() =>{
      this.download();
    })
  }   

  download(){
    var opts = {
      centered : false,
      // getImage :function(tagValue, tagName) {
      //   try {
      //     var fileContents = fs.readFileSync(tagValue);
      //   } catch (err) {
      //     console.log(err);
      //     // Here you get the error when the file was not found,
      //     // but you also get any other error
      //   }
      //   console.log(fs.readFileSync(tagValue))
      //   return fs.readFileSync(tagValue);
      // },
      getImage: function(image){
        return image;
      },
    
     getSize: function(img,tagValue, tagName) {
       if (tagName == 'imageCB'){
          return [100,33];}
           if (tagName == 'barcode'){
          return [100,33]
       }else{
        return [300,204];
       }
      
      }

    }

    var imageModule=new ImageModule(opts);
    var _this = this;
   
    this.loadFile("assets/purchase_template.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
     /* var productos = new Array(); 
      productos.push(_this.purchaseProducts.product);*/
       
     
      var products = [];
      _this.purchaseProducts.forEach(function (purchaseProduct){
        products.push(purchaseProduct.product)
      })
            
      doc.setData({
          products: products,
          imageCB:_this.purchase.barcode_img?_this.base64DataURLToArrayBuffer(_this.purchase.barcode_img.substring(0,_this.purchase.barcode_img.length-1)):'',
          price:_this.purchase.total_amount != undefined? _this.purchase.total_amount: '',
          telephone1:_this.purchase.person.telephone != undefined? _this.purchase.person.telephone: '',
          telephone2:_this.purchase.person.mobile != undefined? _this.purchase.person.mobile: '',
          cp:_this.purchase.person.cp != undefined? _this.purchase.person.cp: '',
          number_purchase:_this.purchase.id != undefined? _this.purchase.id: '',
          newdate:_this.getDateForFooter(_this.purchase.createdAt),
          purchase: [
            {
            first_name: _this.purchase.person.name+' '+ _this.purchase.surname != undefined? _this.purchase.person.name+' '+_this.purchase.person.surname: '', 
            born_date:_this.purchase.person.born_date?moment(_this.purchase.person.born_date).format("DD-MM-YYYY"):'',
            NIF:_this.purchase.person.nif != undefined? _this.purchase.person.nif: '',
            address:_this.purchase.person.address != undefined? _this.purchase.person.address: '',
            town:_this.purchase.person.town != undefined? _this.purchase.person.town: '',
            state:_this.purchase.person.state != undefined? _this.purchase.person.state: '',
            descrip:products,
            shop:_this.purchase.shop.name != undefined? _this.purchase.shop.name: '',
            address_shop:_this.purchase.shop.address  != undefined? _this.purchase.shop.address: '',
            telephone_shop:_this.purchase.shop.telephone != undefined? _this.purchase.shop.telephone: '',
            attended: _this.purchase.createdByNameAndSurname!= undefined?  _this.purchase.createdByNameAndSurname: '',
             } 
                    ]
              });
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      
      FileSaver.saveAs(out, 'Compra.docx'); 
      _this.markAsPrinted();   
  })
}

download_purchase_int(){

    var opts = {
      centered : false,
      // getImage :function(tagValue, tagName) {
      //   try {
      //     var fileContents = fs.readFileSync(tagValue);
      //   } catch (err) {
      //     console.log(err);
      //     // Here you get the error when the file was not found,
      //     // but you also get any other error
      //   }
      //   console.log(fs.readFileSync(tagValue))
      //   return fs.readFileSync(tagValue);
      // },
      getImage: function(image){
        return image;
      },
    
     getSize: function(img,tagValue, tagName) {
       if (tagName == 'imageCB'){
          return [100,33];}
           if (tagName == 'barcode'){
          return [100,33]
       }else{
        return [300,204];
       }
      
      }

    }

    var imageModule=new ImageModule(opts);
    var _this = this;
   
    this.loadFile("assets/purchase_template_inter.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
     /* var productos = new Array(); 
      productos.push(_this.purchaseProducts.product);*/
       
     
      var products = [];
      _this.purchaseProducts.forEach(function (purchaseProduct){
        products.push(purchaseProduct.product)
      })
            
      doc.setData({
          products: products,
          imageCB:_this.purchase.barcode_img?_this.base64DataURLToArrayBuffer(_this.purchase.barcode_img.substring(0,_this.purchase.barcode_img.length-1)):"",
          price:_this.purchase.total_amount != undefined? _this.purchase.total_amount: '',  
          telephone1:_this.purchase.person.telephone,
          telephone2:_this.purchase.person.mobile != undefined? _this.purchase.person.mobile: '',
          cp:_this.purchase.person.cp != undefined? _this.purchase.person.cp: '', 
          number_purchase:_this.purchase.id  != undefined? _this.purchase.id: '',
          newdate:_this.getDateForFooter(_this.purchase.createdAt),
          purchase: [
            {
            first_name: _this.purchase.nameAndSurname != undefined? _this.purchase.nameAndSurname: '',
            born_date:_this.purchase.person.born_date?moment(_this.purchase.person.born_date).format("DD-MM-YYYY"):'',
            NIF:_this.purchase.person.nif != undefined? _this.purchase.nif: '',
            address:_this.purchase.person.address != undefined? _this.purchase.person.address: '',
            town:_this.purchase.person.town != undefined? _this.purchase.person.town: '',
            descrip:products,
            address_shop:_this.purchase.shop.address != undefined? _this.purchase.shop.address: '',
            telephone_shop:_this.purchase.shop.telephone != undefined? _this.purchase.shop.telephone: '',
            attended:_this.purchase.createdByNameAndSurname != undefined? _this.purchase.createdByNameAndSurname: '',
            state:_this.purchase.person.state != undefined? _this.purchase.person.state: '',
           
             } 
                    ]
              });
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      
      FileSaver.saveAs(out, 'Compra interna.docx'); 
      _this.markAsPrinted();   
  })

}


}



// WEBPACK FOOTER //
// ./src/app/purchase/components/purchase.component.ts